import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

const UrlServicesContext = createContext();
const { Provider, Consumer } = UrlServicesContext;

function UrlServicesProvider({ children }) {
  /* ### API ### */
  //const [urlWeb] = useState("http://localhost:3003/");
  /*const [urlWeb] = useState("http://localhost:3000/");
  const [urlServices] = useState("http://localhost:3002/");*/

  const [urlWeb] = useState("https://web.booknpays.com/");
  const [urlServices] = useState("https://api.booknpays.com/");

  /*  ### PLACETOPAY ### */
  const [LightboxPlaceToPay] = useState(
    "https://checkout.placetopay.com/lightbox.min.js",
  );

  const [UserAuth, setUserAuth] = useState(() => {
    const storedSession = localStorage.getItem("Session");
    return storedSession
      ? { Session: storedSession }
      : {
          id: "",
          Session: null,
          name: "",
          lastname: "",
          allname: "",
          documentId: "",
          email: "",
          phone: "",
          avatar: null,
          profile_id: "",
          profile_name: "",
          clients_id: "",
          clientsName: "",
          createdAt: "",
          gender: "",
          status: "",
          lastLogin: "",
          passwordTmp: "",
          iva: "",
          ivaHoliday: "",
          address: "",
          nameBank: "",
          numberAccountBank: "",
        };
  });

  useEffect(() => {
    const fetchData = async () => {
      const datavalue = { token: localStorage.getItem("Session") };

      if (localStorage.getItem("Session") !== null) {
        try {
          const response = await axios.post(
            `${urlServices}auth/validate-token`,
            datavalue,
          );

          setUserAuth({
            ...UserAuth,
            id: response.data.user?.id,
            name: response.data.user?.companyName
              ? null
              : response.data.user?.name,
            lastname: response.data.user?.companyName
              ? null
              : response.data.user?.lastName,
            allname: response.data.user?.companyName
              ? null
              : response.data.user?.name + " " + response.data.user?.lastName,
            documentId: response.data.user?.documentId,
            email: response.data.user?.email,
            phone: response.data.user?.phone,
            avatar:
              response.data.user?.avatar === ""
                ? null
                : response.data.user?.avatar,
            profile_id: response.data.user?.companyName
              ? null
              : response.data.user?.profileId,
            profile_name: response.data.user?.companyName
              ? null
              : response.data.user?.profile?.name,
            clients_id: response.data.user?.id,
            clientsName: response.data.user?.companyName,
            createdAt: response.data.user?.createdAt,
            gender: response.data.user?.companyName
              ? null
              : response.data.user?.genderId,
            status: response.data.user?.status,
            lastLogin:
              response.data.user?.logSystem?.length > 0
                ? response.data.user?.logSystem[0].createdAt
                : "",
            passwordTmp: response.data.user?.passwordTmp,
            iva: response.data.iva,
            ivaHoliday: response.data.ivaHoliday,
            address: response.data.user?.address,
            nameBank: response.data.user?.nameBank,
            numberAccountBank: response.data.user?.numberAccountBank,
          });
        } catch (error) {
          // Manejar errores aquí, por ejemplo, mostrar un mensaje de error o realizar alguna acción específica
          localStorage.removeItem("Session");
          console.error("Error en el acceso:", error);
        }
      }
    };

    fetchData();
  }, []);

  const LoginAuth = (userData) => {
    setUserAuth({
      ...UserAuth,
      id: userData.data?.id,
      Session: userData.token,
      name: userData.data?.companyName ? null : userData.data?.name,
      lastname: userData.data?.companyName ? null : userData.data?.lastName,
      allname: userData.data?.companyName
        ? null
        : userData.data?.name + " " + userData.data?.lastName,
      documentId: userData.data?.documentId,
      avatar: userData.data?.avatar === "" ? null : userData.data?.avatar,
      email: userData.data?.email,
      phone: userData.data?.phone,
      profile_id: userData.data?.companyName ? null : userData.data?.profileId,
      profile_name: userData.data?.companyName
        ? null
        : userData.data?.profile?.name,
      clients_id: userData.data?.id,
      clientsName: userData.data?.companyName,
      createdAt: userData.data?.createdAt,
      gender: userData.data?.companyName ? null : userData.data?.genderId,
      status: userData.data?.status,
      lastLogin:
        userData.data?.logSystem?.length > 0
          ? userData.data?.logSystem[0].createdAt
          : "",
      passwordTmp: userData.data?.passwordTmp,
      iva: userData.iva,
      ivaHoliday: userData.ivaHoliday,
      address: userData.data.address,
      nameBank: userData.data.nameBank,
      numberAccountBank: userData.data.numberAccountBank,
    });
    localStorage.setItem("Session", userData.token);
  };

  const LogoutAuth = () => {
    setUserAuth({
      ...UserAuth,
      id: "",
      Session: null,
      name: "",
      lastname: "",
      allname: "",
      documentId: "",
      phone: "",
      email: "",
      avatar: null,
      profile_id: "",
      profile_name: "",
      clients_id: "",
      clientsName: "",
      createdAt: "",
      gender: "",
      status: "",
      lastLogin: "",
      passwordTmp: "",
      iva: "",
      address: "",
      nameBank: "",
      numberAccountBank: "",
    });
    localStorage.removeItem("Session");
  };
  const UpdateUserAuth = (newUserData) => {
    setUserAuth({
      ...UserAuth,
      ...newUserData,
    });
  };

  return (
    <Provider
      value={{
        urlServices,
        urlWeb,
        UserAuth,
        LoginAuth,
        LogoutAuth,
        UpdateUserAuth,
        LightboxPlaceToPay,
      }}
    >
      {children}
    </Provider>
  );
}

export {
  UrlServicesProvider,
  Consumer as urlServicesConsumer,
  UrlServicesContext,
};
